import React from 'react';
import Marketplace from '@/pages/Marketplace';

const LaserMarketplace = () => {
  return <Marketplace discipline="laser_cutting" />;
};

export default LaserMarketplace;
